import React from "react";
import { withRouteData } from "react-static";
import Routes from "react-static-routes";

import NavBar from "./components/navBar";

const homeBackgroundStyle = {
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center center",
  backgroundImage: "url(/images/home-background.png)",
  backgroundSize: "cover",
  minHeight: "100vh"
};

const AppLayout = props => {
  const applyCustomStyle =
    props.history.location.pathname === "/" ||
    props.history.location.pathname === "/dl/";

  return (
    <div style={applyCustomStyle ? homeBackgroundStyle : null}>
      <NavBar applyCustomStyle={applyCustomStyle} />
      <div>
        <Routes />
      </div>
    </div>
  );
};

export default withRouteData(AppLayout);



// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/app-layout.js